import React, {useContext} from "react";
import ClienteDirectoContext from "../../context/ClienteDirectoContext";

export function ContactText({withThanks = false}) {
    const {datosPolkista, datosMaster} = useContext(ClienteDirectoContext);

    return (
        <p>
            {withThanks && <span> Gracias por cotizar con nosotros. <br/> </span>} En breve, {datosPolkista?.Apellido ?? datosMaster?.apellido ? `el equipo de ${datosPolkista?.Nombre ?? datosMaster?.nombre} ${datosPolkista?.Apellido ?? datosMaster?.apellido} te contactará` : "un productor te contactará"} para finalizar tu póliza.
        </p>
    )
}